"use strict";

exports.__esModule = true;
exports.ToolbarDescription = ToolbarDescription;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
var _excluded = ["children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var Description = _styledComponents["default"].div.withConfig({
  displayName: "ToolbarDescription__Description",
  componentId: "sc-15dipzb-0"
})(["color:", ";font-size:", ";margin:auto 10px;"], (0, _Theme.val)("ToolbarTextColor"), (0, _Theme.val)("fontSizeLarge"));

/**
 * Displays Toolbar Description.
 */
function ToolbarDescription(_ref) {
  var children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Description, props, children);
}